import { render } from "./ProductDetailPimTabTextFragmentCard.vue?vue&type=template&id=846e0b60&scoped=true&ts=true"
import script from "./ProductDetailPimTabTextFragmentCard.vue?vue&type=script&lang=ts"
export * from "./ProductDetailPimTabTextFragmentCard.vue?vue&type=script&lang=ts"

import "./ProductDetailPimTabTextFragmentCard.vue?vue&type=style&index=0&id=846e0b60&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-846e0b60"]])

export default __exports__